import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import Vuex from 'vuex'
import VueRouter from 'vue-router'
import store from './store/index'
import router from './router'
import VeeValidate from 'vee-validate'
import SpTooltip from './components/SpTooltip'
import { VExpansionPanel } from 'vuetify/lib';
import Toasted from 'vue-toasted'

const toastedOptions = {
  position: 'top-right',
  keepOnHover: true,
  duration: 6000,
  action: [
    {
      icon: 'close',
      onClick: (e, toastObject) => {
        toastObject.goAway(0)
      },
    },
  ],
  iconPack: 'material',
  router,
}

Vue.use(Toasted, toastedOptions)

Vue.use(VueRouter)
Vue.use(Vuex)
Vue.config.productionTip = false

import i18n from './i18n'

Vue.use(VeeValidate, 
  {
    i18n,
    i18nRootKey: 'validations'
  }
);

var filter = function(text, length){
  var node = document.createElement('div');
  node.innerHTML = text;
  var content = node.textContent;
  return content.length > length ? content.slice(0, length) + '...' : content;
};

Vue.filter('truncate',filter)

Vue.component("sp-tooltip",SpTooltip)
Vue.component("v-expansion-panel",VExpansionPanel)

new Vue({
  render: h => h(App),
  router,
  i18n,
  store
}).$mount('#app')
